import script from "./App.vue?vue&type=script&lang=js&setup=true"
export * from "./App.vue?vue&type=script&lang=js&setup=true"

import "./App.vue?vue&type=style&index=0&id=3d2f9320&lang=scss"

const __exports__ = script;

export default __exports__